import React from 'react'
import {Typography} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import {makeStyles} from '@material-ui/core/styles'
import * as Api from 'lib/api'
import {useAuthentication} from 'components/providers/AuthenticationProvider'
import {ProductList} from 'components/organisms/products'
import {Link} from 'react-router-dom'
import {EmptyResources} from 'components/molecules/EmptyResources'
import {FormattedMessage, useIntl} from 'react-intl'

const useStyles = makeStyles(theme => ({
  actionsBar: {
    padding: theme.spacing(2, 0),
  },
}))

export default function ProductsPage() {
  const classes = useStyles()
  const intl = useIntl()
  const {tenant} = useAuthentication()
  const [isLoading, setIsLoading] = React.useState(true)
  const [totalCount, setTotalCount] = React.useState(0)
  const [errorMessage, setErrorMessage] = React.useState(null)
  const [products, setProducts] = React.useState([])

  React.useEffect(() => {
    async function fetchData() {
      const response = await Api.getTenantProducts(tenant.id, 1)
      response.matchWith({
        Ok: ({value}) => {
          setProducts(value.content)
          setTotalCount(value.totalCount)
        },
        Error: ({value}) => {
          setErrorMessage(value.message)
        },
      })
      setIsLoading(false)
    }

    fetchData()
  }, [tenant.id])

  const renderContent = () => {
    if (isLoading) {
      return (
        <Typography variant="h5" component="h2">
          <FormattedMessage id="loading" defaultMessage="Loading..." />
        </Typography>
      )
    }

    if (errorMessage) {
      return (
        <Typography variant="h5" component="h2" color="error">
          <FormattedMessage
            id="somethingWentWrong"
            defaultMessage="Something went wrong"
          />
        </Typography>
      )
    }

    if (totalCount === 0) {
      return (
        <EmptyResources
          message={intl.formatMessage({
            id: 'products.noProductsFound',
            defaultMessage: 'No products found',
          })}
        />
      )
    }

    return <ProductList products={products} />
  }

  return (
    <>
      <Grid container justify="space-between" className={classes.actionsBar}>
        <Grid item>
          <Typography variant="h6">
            <FormattedMessage id="navs.products" defaultMessage="Products" />
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="small"
            color="primary"
            component={Link}
            to="/products/add"
          >
            <FormattedMessage
              id="products.addProduct"
              defaultMessage="Add product"
            />
          </Button>
        </Grid>
      </Grid>
      {renderContent()}
    </>
  )
}
